import { render } from "./logo-rss.vue?vue&type=template&id=10469602"
import script from "./logo-rss.vue?vue&type=script&lang=js"
export * from "./logo-rss.vue?vue&type=script&lang=js"
script.render = render

export default script